import BaseUseCase from "../../../base_use_case.js";

class ShowUserUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/users/users/${identifier}`,
    });
  }
}

const instance = new ShowUserUseCase();
export default instance;